module.exports = "/_next/static/images/Hero-e769aa875501257ad9c9a73f8e78e807.webp";